<script setup>
import {useUsersStore, useVarsStore} from '@/stores'
import { useDesignSystem } from '@/composables/useDesignSystem'
import moment from 'moment'
import Tooltip from '@/layouts/components/Tooltip.vue'
import AppDateTimePicker from '@core/components/AppDateTimePicker.vue'
import {
  emailValidator,
  requiredValidator,
} from '@validators'

const { dialogWidth } = useDesignSystem()
const dWidth = dialogWidth('md')

const varsStore = useVarsStore()
let globalSettings = null
let editingGlobalSettings = null;
({globalSettings, editingGlobalSettings } = storeToRefs(varsStore))
varsStore.getGlobalSettings()

const usersStore = useUsersStore()
let myUser = null;
({ myUser } = storeToRefs(usersStore))


const addFreeSubscription = ref(false)

const form = ref()
const valid = ref(true)
const newSettingName = ref("")
const onFormSubmit = async () => {
  form.value.validate().then(async ({valid: isValid}) => {
    if(isValid){
      let newId = await usersStore.saveAdminEditingUser()
      if(addFreeSubscription.value){
        await usersStore.adminEditUserSubscription(newId)
      }
    }

  })

}

const addNewSetting = async () => {
  globalSettings.value.push({name: newSettingName.value, value: ""})
}
</script>

<template>
  <VDialog
    v-if="editingGlobalSettings && myUser.userLevel == 'admin'"
    v-model="editingGlobalSettings"
    :width="dWidth"
    persistent
  >
    <VCard class="pa-sm-9 pa-5">
      <VCardItem class="text-center">
        <VCardTitle class="text-h5">
          Global Settings
        </VCardTitle>
        <VCardSubtitle>
          Edit with Care
        </VCardSubtitle>
      </VCardItem>

      <VCardText>
        <!-- 👉 Form -->
        <VForm
          ref="form"
          class="mt-6"
          @submit.prevent="onFormSubmit"
        >
          <VRow>
            <VCol
              v-for="(setting, index) in globalSettings"
              :key="index"
              cols="12"
            >
              <VSelect
                v-if="setting.type == 'string' && setting.values"
                v-model="setting.value"
                :items="setting.values"
                :label="setting.name"
                :hint="setting.description"
                autocomplete="null"
                persistent-hint
              />
              <VTextField
                v-else-if="setting.type == 'string'"
                v-model="setting.value"
                :label="setting.name"
                :hint="setting.description"
                autocomplete="null"
                persistent-hint
              />
              <VCheckbox
                v-else-if="setting.type == 'boolean'"
                v-model="setting.value"
                :label="setting.name"
                :hint="setting.description"
                persistent-hint
              />
            </VCol>
            <!-- 👉 Submit and Cancel -->
            <VCol
              cols="12"
              class="d-flex flex-wrap justify-center gap-4"
            >
              <VBtn
                v-if="true"
                @click="varsStore.saveGlobalSettings(); editingGlobalSettings = false; "
              >
                Save
              </VBtn>
              <VBtn
                color="secondary"
                variant="tonal"
                @click="varsStore.getGlobalSettings(); editingGlobalSettings = false; "
              >
                Cancel
              </VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardText>
    </VCard>
  </VDialog>
</template>
